import type { NextApiRequest } from 'next';
import {
  GeneralQueryParams,
  ProjectBoundsQueryParams,
  ProjectQueryParams,
  yad1Client,
} from '@y2/api-clients/yad1';

import { CLIENT_QUERY_KEYS } from '../services/params/consts';

const { getProjects, getProjectsByBounds } = yad1Client();

const isBoundsQuery = (
  query: GeneralQueryParams,
): query is ProjectBoundsQueryParams => CLIENT_QUERY_KEYS.BOUNDS in query;

export const projectFetcher = (
  query: GeneralQueryParams,
  reqHeaders?: NextApiRequest['headers'],
) =>
  isBoundsQuery(query)
    ? getProjectsByBounds(query as ProjectBoundsQueryParams, reqHeaders)
    : getProjects(query as ProjectQueryParams, reqHeaders);
